import { Card, Progress, Stack, useLang } from "@manulife/mux";
import { useDispatch, useSelector } from "react-redux";
import AssumptionsDisclaimersModal from "./AssumptionsDisclaimersRenewal";
import { useEffect, useState } from "react";
import RtgDownloadEmail from "./RtgDownloadEmail";
import { fetchCharts } from "../../appRedux/chart/Actions";
import { isObjectEmpty } from "../../services/helpers/objectUtilities";
import UnderwritingRiskModal from "./UnderwritingRiskModal";
import RtgTableVersionModal from "./RtgTableVersion";
import RtgChartTabContent from "./RtgChartTabContent";

function NewPurchaseTab() {
  const selectedLang = useLang();
  const dispatch = useDispatch();
  const validatedData = useSelector(
    (state) => state.rportReducer?.validatedData
  );

  const reportPdfBase64str = useSelector(
    (state) => state.chartReducer?.chartsData?.illustration?.report?.data || ""
  );

  const [isUnderwritingRiskModalOpen, setUnderwritingRiskModalOpen] = useState(false);

  function openUnderwritingRiskModal() {
    setUnderwritingRiskModalOpen(true);
  }

  function closeUnderwritingRiskModal() {
    setUnderwritingRiskModalOpen(false);
  }

  const [isAssumptionsDisclaimersModalOpen, setAssumptionsDisclaimersModalOpen] = useState(false);

  function openAssumptionsDisclaimersModal() {
    setAssumptionsDisclaimersModalOpen(true);
  }

  function closeAssumptionsDisclaimersModal() {
    setAssumptionsDisclaimersModalOpen(false);
  }

  const [isTableVersionModalOpen, setTableVersionModalOpen] = useState(false);

  function opeTableVersionModal() {
    setTableVersionModalOpen(true);
  }

  function closeTableVersionModal() {
    setTableVersionModalOpen(false);
  }

  const chartData = useSelector(
    (state) => state.chartReducer?.chartsData?.illustration?.report?.graph.find(ele => ele.type === "PremiumCompareNewPolicy")
  );

  const [isOpening, setIsOpening] = useState(true);

  useEffect(() => {
    if (reportPdfBase64str === "" && !isObjectEmpty(validatedData) && dispatch && isOpening) {
      setIsOpening(false);
      dispatch(
        fetchCharts({
          ...validatedData,
          isDownloadPDF: true,
          reportType: "PremiumCompare"
        })
      );
    }
  }, [reportPdfBase64str, dispatch, validatedData, isOpening]);

  // Render the chart data if available, otherwise show a loading spinner
  return chartData ? (
    <>
      <RtgChartTabContent
        chartData={chartData}
        validatedData={validatedData}
        selectedLang={selectedLang}
        onTableVersionClick={(e) => {
          e.preventDefault();
          opeTableVersionModal();
        }}
        onUnderwritingRiskClick={(e) => {
          e.preventDefault();
          openUnderwritingRiskModal();
        }}
        onAssumptionsDisclaimersClick={(e) => {
          e.preventDefault();
          openAssumptionsDisclaimersModal();
        }}
      />
      <Card.Separator />
      <RtgDownloadEmail />
      <UnderwritingRiskModal isModalOpen={isUnderwritingRiskModalOpen} closeModal={closeUnderwritingRiskModal} />
      <AssumptionsDisclaimersModal isModalOpen={isAssumptionsDisclaimersModalOpen} closeModal={closeAssumptionsDisclaimersModal} />
      {chartData && (
        <RtgTableVersionModal
          isModalOpen={isTableVersionModalOpen}
          closeModal={closeTableVersionModal}
          chartData={chartData}
        />
      )}
    </>
  ) : (
    <Card.Content>
      <Stack justify="center" style={{ minHeight: '420px' }}>
        <Stack direction="row" justify="center">
          <Progress isFloating={false} />
        </Stack>
      </Stack>
    </Card.Content>
  );
};

export default NewPurchaseTab;
